<template>
  <div>
    <div class="w3-container">
      <div class="headerGrid w3-hide-print">
        <div>
          <header>
            <h2>Domains</h2>
          </header>
        </div>
      </div>

      <div class="outline">
        <header class="light outline">
          <h5 class="comfortaa">Domain Search</h5>
          <p>Find your new domain</p>
        </header>

        <div class="w3-row">
          <div class="w3-container w3-white">
            <div class="w3-row w3-section">
              <div class="w3-col s10 m11">
                <input class="w3-input w3-border" name="domainName" type="text" placeholder="domain.com" v-model="domainName" v-bind:class="{'w3-border-red':searchError}" @blur="searchError = false" v-on:keyup.enter="domainSearch()">
              </div>
              <div class="w3-col s2 m1" style="padding-top:1px;">
                <button class="w3-button w3-green w3-block" style="border-radius:0 3px 3px 0;" type="submit" @click="domainSearch()">GO</button>
              </div>
            </div>
          </div>
        </div>
        <div class="w3-row w3-margin-bottom">
          <div v-if="Object.keys(state.currentDomainSearch).length > 0">
            <table class="w3-table domainResults w3-white" :class="state.width > 1024 ? '' : 'w3-responsive'">
              <tr class="w3-light-grey outline">
                <td>Domain</td>
                <td class="w3-center" style="width:120px;">Status</td>
                <td class="w3-center" style="width:120px;">Price</td>
                <td class="w3-center" style="width:120px;">Purchase</td>
              </tr>
              <tr v-for="(item, key, i) in state.currentDomainSearch" :key="i" class="domainRow">
                <td>{{key}}</td>
                <td class="w3-text-green w3-center" v-if="item.status == 'available'">Available</td>
                <td class="w3-disabled w3-center" v-else>Unavailable</td>
                <td class="w3-center"><b>$15.00</b><span style="font-size:9pt;"> / year</span></td>
                <td class="w3-center">
                  <button class="w3-button w3-small w3-red" v-if="item.status == ('regthroughothers' || 'regthroughus')">UNAVAILABLE</button>
                  <button class="w3-button w3-small w3-green" v-if="item.status == 'available'" @click="cartAddDomain(key, item)">ADD TO CART</button>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    
    <!-- My Domains -->
    <div class="w3-container">
      <domainsList></domainsList>
    </div>
  </div>
</template>

<script>
import domainsList from '@/components/domainsList'
import axios from "axios";
var dataStore = require("../dataStore").default;

export default {
  name: "Domains",
  data() {
    return {
      state: dataStore.state,
      domainName: "",
      tlds: ["com", "net", "org"],
      pageNumber: 1,
      searchError: false,
      domainPlan: null
    };
  },
  methods: {
    domainSearch() {
      this.state.loading = true
      this.state.currentDomainSearch = {}
      if (this.domainName == "") {
        this.searchError = true
        return
      }
      axios.get(this.state.mainURL + "?general=domainSearch&domain-name=" + this.domainName + "&tlds=" + this.tlds).then((response) => {
        this.state.currentDomainSearch = response.data
        this.state.loading = false
      });
    },
    cartAddDomain(key, item) {
      if (this.state.domainPlan) {
        let domainObj = {
          plan: this.state.domainPlan,
          domain: key,
          description: 'Domain Registration - ' + key,
          period: 'year',
          duration: 1,
          amount: 1500
        }

        for (let obj of this.state.cart.items) {
          if (JSON.stringify(obj) === JSON.stringify(domainObj)) {
            alert('Item already in cart')
            return
          }
        }
        this.state.cart.items.push(domainObj)
        this.state.modals.cartAdded = true
      } else {
        alert('No domain plan available. Please contact us for support.')
        return
      }
    }
  },
  components: {
    domainsList
  }
};
</script>

<style scoped>
.domainRow {border-bottom:1px solid #eee;}
.domainRow:last-child {border-bottom:0;}
/* .domainRow:hover {background: #fafafa;} */
</style>



// WEBPACK FOOTER //
// src/components/Domains.vue